import { Component, OnInit } from '@angular/core';
import { BookingStepService } from '../../services/booking-step.service';
import { LocalizationService } from '../../../../services/localization.service';
import { environment } from '../../../../../environments/environment';
import { BookingOrderService } from '../../services/booking-order.service';

@Component({
  selector: 'app-booking-order-title',
  templateUrl: './booking-order-title.component.html',
  styleUrls: ['./booking-order-title.component.css']
})
export class BookingOrderTitleComponent implements OnInit {

  private _bookingDate = '';
  private _bookingDateStartTime = '';
  private _bookingDateEndTime = '';

  constructor(
    protected bookingStepService: BookingStepService,
    private localizationService: LocalizationService,
    private bookingOrderService: BookingOrderService,
  ) {
  }

  ngOnInit(): void {
    this.reloadOrderBookingHeaderSettings();
  }

  reloadOrderBookingHeaderSettings(): string {
    const date = this.bookingOrderService.selectedBookingDate;
    const selectedBookingSlot = this.bookingOrderService.selectedBookingSlots && this.bookingOrderService.selectedBookingSlots.length
      ? this.bookingOrderService.selectedBookingSlots[0]
      : null;
    if (date == null || selectedBookingSlot == null) {
      return '';
    }
    this._bookingDate = this.localizationService.formatDate(date);
    this._bookingDateStartTime = environment.globalSettings.toTimeString(selectedBookingSlot.fromTime);

    const bookingDateEndTimeFloat = this.bookingOrderService.isEventTypeOrder ? selectedBookingSlot.toTime
      : selectedBookingSlot.fromTime + environment.globalSettings.minutesToFloat(this.bookingOrderService.maximalDurationTimeOfProduct);
    this._bookingDateEndTime = environment.globalSettings.toTimeString(bookingDateEndTimeFloat);
  }

  get bookingDate(): string {
    return this._bookingDate;
  }
  get bookingDateStartTime(): string {
    return this._bookingDateStartTime;
  }
  get bookingDateEndTime(): string {
    return this._bookingDateEndTime;
  }
}
